import { openSecurityRequest } from '@/utils/request'
import { appCode } from '@/utils/singleApp'

// 查询当前域名的配置
export const queryDomainConfig = () => {
    return openSecurityRequest.get('/open/security/appConfig/find', {
        params: {
            appCode
        }
    })
}

// 查询当前域名的配置列表
export const queryDomainConfigList = () => {
    return openSecurityRequest.get('/open/security/appConfig/list')
}
